import { Controller } from '@hotwired/stimulus';

const debounceTimeout = 200;

export default class extends Controller {
  static targets = ['searchIcon', 'searchInput'];

  connect() {
    this.modal = document.getElementById('multi-search-modal');
    this.bsModal = null;

    if (this.modal) {
      this.modal.addEventListener('shown.bs.modal', () => this.focusSearchInput());
      this.modal.addEventListener('hidden.bs.modal', () => {
        this.clearSearchInput();
        this.updateSearchResults();
      });
    }

    this.searchTimer = null;
  }

  disconnect() {
    if (this.modal) {
      this.modal.removeEventListener('shown.bs.modal', () => this.focusSearchInput());
      this.modal.removeEventListener('hidden.bs.modal', () => {
        this.clearSearchInput();
        this.updateSearchResults();
      });
    }

    // Clean up Bootstrap modal instance
    if (this.bsModal) {
      this.bsModal.dispose();
      this.bsModal = null;
    }
  }

  showModal(event) {
    event.preventDefault();
    if (window.bootstrap && this.modal) {
      // Create or reuse the Bootstrap modal instance
      if (!this.bsModal) {
        this.bsModal = new window.bootstrap.Modal(this.modal);
      }
      this.bsModal.show();
    }
  }

  updateSearchResults() {
    this.setLoading(true);
    
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, debounceTimeout);
  }

  search() {
    const form = this.searchInputTarget.form;
    if (form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      
      fetch(form.action + '?' + searchParams.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'text/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        }
      })
      .then(response => response.text())
      .then(html => {
        // Create a script element and execute the returned JS safely
        const script = document.createElement('script');
        script.textContent = html;
        document.head.appendChild(script);
        document.head.removeChild(script);
        this.removeLoading();
      })
      .catch(error => {
        console.error('Search error:', error);
        this.removeLoading();
      });
    }
  }

  removeLoading() {
    this.setLoading(false);
  }

  setLoading(searching) {
    if (searching) {
      this.searchIconTarget.classList.remove('fa', 'fa-search');
      this.searchIconTarget.classList.add('fas', 'fa-spinner', 'fa-spin');
    } else {
      this.searchIconTarget.classList.remove('fas', 'fa-spinner', 'fa-spin');
      this.searchIconTarget.classList.add('fa', 'fa-search');
    }
  }

  clearSearchInput() {
    this.searchInputTarget.value = '';
  }

  focusSearchInput() {
    this.searchInputTarget.focus();
  }
}